import { ref } from 'vue'

export default function useCarouselScroll() {
	const scrollTo = (prop, refs, orientation = 'right') => {
		if (!refs[prop]) return false

		let reference = refs[prop]
		if (Array.isArray(reference)) reference = reference[0]

		let position = reference.getScrollPosition().left

		return orientation === 'left'
			? reference.setScrollPosition('horizontal', position - 300, 200)
			: reference.setScrollPosition('horizontal', position + 300, 200)
	}

	return scrollTo
}
